import { VStack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import React from 'react';

export const Home: React.FC = () => (
  <VStack bgColor={'blue.900'} align="center" justify="center" h="100%">
    <Image image="logo-white" w={200} />
  </VStack>
);
